module.exports = __webpack_public_path__ + "img/E42E12_F35132_F86949_B71B0A-256px.0b9b25f9.png";